// extracted by mini-css-extract-plugin
export var closeButton = "_ib-1";
export var closeX = "_ib-3";
export var container = "_ib-0";
export var image = "_ib-2";